import Head from './TopHead';
import Curric from './Curric';

function Excel() {
    return (
        <main>
            <Head />

            <h1>Microsoft Excel (365)</h1>

            <section className="section">
                <h2>Excel Fundamental Skills: 6 Levels</h2>

                <div className="sectional">
                    <small className="hide-print">Click to see material covered.</small>

                    <Curric title="Level 1 - Introduction - Learn Basics (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> You'll learn how to perform everyday office tasks in Excel, create
                            spreadsheets with basic formulas, organize and filter data.
                        </div>
                        <ul>
                            <li>Format, Layout & Design New Spreadsheets</li>
                            <li>Merged Cells</li>
                            <li>Basic Conditional Formatting</li>
                            <li>Build Basic Dropdown Selections in Cells</li>
                            <li>Basic Formulas</li>
                            <li>The FILL Handle</li>
                            <li>Absolute & Relative References</li>
                            <li>Calculations: Formulas and Functions (SUM, AVERAGE, COUNT, COUNTA, MAX, MIN)</li>
                            <li>Sorting & Filtering Data</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Basic computer skills, including saving and
                            locating files, and proficiency with a basic calculator.</div>
                    </Curric>

                    <Curric title="Level 2 - Intermediate (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> You'll learn how to interlink data between sheets, and create more
                            complex spreadheets that automatically update with newly added data.
                        </div>
                        <ul>
                            <li>Function Syntax & Multiple Arguments</li>
                            <li>TODAY function</li>
                            <li>Creating Formulas From Other Sheets</li>
                            <li>Creating Formulas From Other Spreadsheets</li>
                            <li>Building Excel Models & Excel Workflow</li>
                            <li>Table Objects</li>
                            <li>Conditional Formatting with Tables</li>
                            <li>Data Validation with Tables</li>
                            <li>Identify Duplicates</li>
                            <li>Remove Duplicates</li>
                            <li>SUMIFS, AVERAGEIFS & COUNTIFS functions</li>
                            <li>CONCATENATE</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Familiarity with Excel's interface and the ability
                            to manually write basic formulas instead of solely relying on built-in buttons. Have some
                            understanding of absolute vs relative references (A1 vs $A$1).</div>
                    </Curric>

                    <Curric title="Level 3 - InterPLUS - Data Analysis (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> You'll learn how to work with data with 1,000s of lines, summarize it,
                            pull related data from other sheets and make some basic charts.
                        </div>
                        <ul>
                            <li>Pivot Tables</li>
                            <li>XLOOKUP & VLOOKUP</li>
                            <li>Merge Data with Lookup Functions</li>
                            <li>Shortcuts for Managing Large Datasets</li>
                            <li>Build Reports from Large Datasets</li>
                            <li>Create Basic Charts</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Must know how to create formulas that link to data
                            located on other sheets, and be familiar with filters.</div>
                    </Curric>


                    <Curric title="Level 4  - Advanced (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> You'll learn how to create complex nested formulas using multiple
                            functions and gain in-depth understanding of data types.
                        </div>
                        <ul>
                        <li>Logical Test</li>
                            <li>AND OR Functions</li>
                            <li>ISNUMBER, ISBLANK Functions</li>
                            <li>ROUND, ROUNUP, ROUNDDOWN functions</li>
                            <li>Nested formulas & functions</li>
                            <li>IF & IFS Functions</li>
                            <li>Working with Dates</li>
                            <li>DATE function</li>
                            <li>ISNUMBER, XMATCH</li>
                            <li>Compare Two Tables for Matching Records</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Must be comfortable with formula syntax, be
                            familiar with VLOOKUP or XLOOKUP.</div>
                    </Curric>

                    <Curric title="Level 5 - AdvancedPLUS (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> You'll learn how to do advanced level tasks, such as 2 way lookups, dynamic array formulas and more.
                        </div>
                        <ul>
                            <li>Advanced Conditional Formatting with Formulas</li>
                            <li>DATEDIF, NETWORKDAYS.INTL</li>
                            <li>INDEX, XMATCH - 2 way lookups </li>
                            <li>Dynamic Array Formulas</li>
                            <li>UNIQUE, SORT</li>
                            <li>FILTER function</li>
                            <li>Lookup with Multiple Matches with FILTER</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Must be comfortable with IF statements, logical tests & XLOOKUP</div>
                    </Curric>
                    <Curric title="Level 6 - Power User (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> You'll learn how to use new dynamic array functions, do complex text operations using regular expressions, create new worksheet functions with LAMBDA and much more!
                        </div>
                        <ul>
                            <li>GROUPBY & PIVOTBY</li>
                            <li>LET function</li>
                            <li>LAMBDA function</li>
                            <li>Create new functions in worksheets</li>
                            <li>MAP, BYROW, REDUCE</li>
                            <li>CHOOSEROWS, CHOOSECOLS</li>
                            <li>REGEXEXTRACT, REGEXREPLACE, REGEXMATCH</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> This course is only suitable for very advanced users.</div>
                    </Curric>
                </div>
            </section>

            <hr />

            <section className="section">
                <h2>Excel Beyond Fundamentals</h2>
                <div className="sectional">
                    <small className="hide-print">Click to see material covered.</small>

                    <Curric title="Create an Excel Dashboard with Data Model & PowerPivot (3 Hours)">
                        <ul>
                            <li>Preparing and Cleaning Data for Dashboards</li>
                            <li>Adding PivotTables</li>
                            <li>Adding Interactivity with Slicers and Controls</li>
                            <li>Report Connections</li>
                            <li>Creating Charts and Graphs for Data Visualization</li>
                            <li>Working with Data Models</li>
                            <li>Creating Measures</li>
                            <li>Managing Relationships with no LOOKUP functions</li>
                            <li>Building and Arranging the Dashboard Layout</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Must be intermediate plus Excel user.</div>
                    </Curric>

                    <Curric title="Excel Dashboard using Power Query (3 Hours)">
                        <ul>
                            <li>Establishing Connetions</li>
                            <li>Connecting Internal & External Data Sources</li>
                            <li>Data Types</li>
                            <li>Adding & Transforming Columns</li>
                            <li>Adding PivotTables</li>
                            <li>Working with Data Models</li>
                            <li>Slicers & Report Connections</li>
                            <li>Using Append & Merge to Combine Data</li>
                            <li>Combine Files in a Folder for a Single Report</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Must be intermediate plus Excel user.</div>
                    </Curric>

                    <Curric title="Create an Excel Dashboard with Formulas Only (4 Hours)">
                        <ul>
                            <li>Preparing and Cleaning Data for Dashboards</li>
                            <li>Essential Excel Formulas for Dashboards</li>
                            <li>SUMIFS, COUNTIFS</li>
                            <li>XLOOKUP</li>
                            <li>Basic IF Statements</li>
                            <li>Adding Dropdowns</li>
                            <li>Applying Impressive Conditional Formatting</li>
                            <li>Sparklines</li>
                            <li>KPIs (Key Performance Indicators)</li>
                            <li>Applying Conditional Formatting with Formula Logic</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Must be advanced Excel user.</div>
                    </Curric>

                    <Curric title="Excel - Q & A (2 Hours)">
                        <ul>
                            <li><strong>Bring Your Questions</strong> - Find Solutions for Specific Excel Problems</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Prepare questions with example files.</div>
                    </Curric>

                    <Curric title="Excel - Just IF Statements (3 Hours)">
                        <ul>
                            <li><strong>Logical Test</strong> - Logical Operators & Logical Functions</li>
                            <li><strong>IF function</strong></li>
                            <li><strong>Combining IF with Logical Functions</strong> - Using IF with AND, OR, and NOT to handle complex conditions.</li>
                            <li><strong>Practical Exercises:</strong> - Hands-on practice with simple IF statements and logical tests.</li>
                            <li><strong>IF with Logical Functions</strong> - ISNUMBER, ISBLANK, ISERR, ISERROR</li>
                            <li><strong>IFS Function</strong> - Simplifying nested conditions using the IFS function.</li>
                            <li><strong>IFERROR, IFNA</strong> - Catch and manage errors in formulas.</li>
                            <li><strong>Practical Exercises:</strong> - IFS and Logical Functions.</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Must be Intermediate Plus user.</div>
                    </Curric>

                    <Curric title="New in Excel 365 (7 Hours Over 2 Days)">
                        <ul>
                            <li>XLOOKUP function</li>
                            <li>VSTACK, HSTACK functions</li>
                            <li>LET function</li>
                            <li>TEXTSPLIT, TEXTAFTER, TEXTBEFORE, TEXTJOIN functions</li>
                            <li>Dynamic Arrays</li>
                            <li>UNIQUE & SORT functions</li>
                            <li>SEQUENCE function</li>
                            <li>FILTER function</li>
                            <li>TAKE, DROP functions</li>
                            <li>LAMBDA function</li>
                            <li>Named functions</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Must be advanced Excel user.</div>
                    </Curric>


                    <Curric title="EXCEL MACROS FOR A BASIC ADVANCED USER (Not Programmer) (3 Hours)">
                        <ul>
                            <li>Introduction to Macros and VBA</li>
                            <li>Setting Up the Developer Tab and Navigating the VBA Environment</li>
                            <li>Recording Basic Macros</li>
                            <li>Tips on Recording Better Macros</li>
                            <li>Basic Understanding of Recorded Macro Code</li>
                            <li>Making Basic Modifications to Existing Macros</li>
                            <li>Introduction to VBA Programming Concepts</li>
                            <li>Writing Simple Macros from Scratch</li>
                            <li>Storing & Using Variables in Code</li>
                            <li>How to Dynamically Find the Last Row in Data</li>
                            <li>How to Use the Last Row in Macros</li>
                            <li>How to Read and Understand Formulas in Macro Code</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Must be advanced Excel user.</div>
                    </Curric>

                    <Curric title="EXCEL MACROS - BASIC VBA PROGRAMMING (4 Hours)">
                        <ul>
                            <li>Basic concepts like variables, data types</li>
                            <li>Range & Cell Objects</li>
                            <li>Testing and Debugging</li>
                            <li>If Then Else Statements</li>
                            <li>For Loops</li>
                            <li>For Each Loops</li>
                            <li>While Loops</li>
                            <li>Understanding Objects, Methods, and Properties</li>
                            <li>Worksheets & Workbooks in VBA</li>
                            <li>Input Boxes and Message Boxes</li>
                            <li>Creating a User-Defined Function (UDF)</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Some programming experience is recommended.</div>
                    </Curric>

                </div>
            </section>


            <hr />

            <section className="section">
                <h2>Excel Power BI - AUTOMATED REPORTS</h2>
                <div className="sectional">
                    <small className="hide-print">Click to see material covered.</small>


                    <Curric title="Excel Power BI - Level 1 POWER PIVOT (3 Hours)">
                        <ul>
                            <li>Enabling Excel Power Pivot</li>
                            <li>Data Models & Data Types</li>
                            <li>Connecting to Internal & External Data Sources</li>
                            <li>Creating Calculated Columns</li>
                            <li>Avoid VLOOKUP by Creating Relationships Between Tables</li>
                            <li>DAX Function Basics</li>
                        </ul>
                    </Curric>

                    <Curric title="Excel Power BI - Level 2 POWER QUERY BASICS (3 Hours)">
                        <ul>
                            <li>Prepare & Reshape Data with Power Query</li>
                            <li>Power Query Editor</li>
                            <li>Connecting Internal & External Data Sources</li>
                            <li>Adding & Transforming Columns</li>
                            <li>Steps in Power Query</li>
                            <li>Using Append & Merge to Join Data</li>
                            <li>Combine Files in a Folder to a Master Dataset</li>
                            <li>Loading Data using a Connection vs loading to Excel</li>
                        </ul>
                    </Curric>

                    <Curric title="Power BI - Level 3 DAX functions (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> This training revolves around learning Data Analysis Expressions (DAX) in Power BI with hands-on assignments to apply DAX functions and concepts.
                        </div>
                        <ul>
                            <li>Introduction to DAX: Welcome, prerequisites, and the importance of DAX in Power BI.</li>
                            <li>Foundations of DAX: Understanding case study data and its model, introduction to calculated columns, tables, and measures.</li>
                            <li>DAX Functions: Overview of various DAX functions including IF, SWITCH, RELATED, ALL, ALLEXCEPT, VALUES, DISTINCT, SUMX, FILTER, and CALCULATE.</li>
                            <li>Contexts in DAX: Explanation of evaluation and filter contexts, row context within measures, context transition, and using CALCULATE function effectively.</li>
                            <li>Advanced DAX: Techniques like aggregators, iterators (like SUMX), and working with filtered aggregates.</li>
                            <li>Time Intelligence: Techniques for time-based calculations using functions like PREVIOUSMONTH, DATESYTD, TOTALYTD, SAMEPERIODLASTYEAR, and CALENDARAUTO.</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Must have experince with Power Pivot and basic DAX functions.</div>
                    </Curric>

                    <Curric title="Excel Power BI - Level 4 POWER QUERY M LANGUAGE (3 Hours)">
                        <ul>
                            <li>Advanced Editor in Power Query</li>
                            <li>M Language Basics</li>
                            <li>Traversing Lists and Tables</li>
                            <li>If Statements in M Language</li>
                            <li>Using Functions in M Language for Advanced Transformations</li>
                            <li>Creating Custom Functions</li>
                            <li>Applying a Custom Function to a Column</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Some programming experience is recommended.</div>
                    </Curric>
                </div>
            </section>

        </main>

    );
}

export default Excel;